<template>
  <div :class="cssClass">
    <div v-if="isActive" class="l-notifications-top__content">
      <Icon2 variant="attention" :size="22" />
      <div class="l-notifications-top__summary">
        <p v-if="isInvalidGa && isInvalidGsc">
          GA・GSCの連携が切れているため、再設定をお願いします。
        </p>
        <p v-else-if="isInvalidGa">
          GAの連携が切れているため、再設定をお願いします。
        </p>
        <p v-else-if="isInvalidGsc">
          GSCの連携が切れているため、再設定をお願いします。
        </p>
      </div>
      <div class="l-notifications-top__btns">
        <Button
          v-if="isInvalidGa"
          variant="main"
          @click="authGaRefreshToken"
          :disabled="isDisabled"
          target="_blank"
          size="w145"
          fsize="f12"
        >
          GAの再設定はこちら
        </Button>
        <Button
          v-if="isInvalidGsc"
          variant="main"
          @click="authGscRefreshToken"
          :disabled="isDisabled"
          target="_blank"
          size="w145"
          fsize="f12"
        >
          GSCの再設定はこちら
        </Button>
      </div>
    </div>
    <Button class="l-notifications-top__toggle" @click="toggle">
      <Icon variant="arrow_u-type02" :size="12" />
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import Icon2 from '@/components/Icon2';
import apiProjects from '@/api/projects';

export default {
  components: {
    Button,
    Icon,
    Icon2
  },

  data() {
    return {
      isActive: true
    };
  },

  computed: {
    project() {
      return this.$store.getters['view/project'];
    },
    cssClass() {
      return {
        'l-notifications-top__item': true,
        'l-notifications-top__item--warn': true,
        'is-active': this.isActive
      };
    },
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    },
    isDisabled() {
      return this.hasOrganizations;
    },
    isInvalidGa() {
      return this.project.isValidGaRefreshToken === '0';
    },
    isInvalidGsc() {
      return this.project.isValidGscRefreshToken === '0';
    }
  },

  methods: {
    toggle() {
      this.isActive = !this.isActive;
      this.$emit('toggle');
    },
    authGaRefreshToken(e) {
      e.preventDefault();
      if (this.isDisabled) {
        return;
      }
      apiProjects.authorization.ga.redirect(this.auth.idToken, this.project.id);
    },
    authGscRefreshToken(e) {
      e.preventDefault();
      if (this.isDisabled) {
        return;
      }
      apiProjects.authorization.gsc.redirect(
        this.auth.idToken,
        this.project.id
      );
    }
  }
};
</script>
